import { Controller } from '@hotwired/stimulus'
import { renderGrid } from '@giphy/js-components'
import { GiphyFetch } from '@giphy/js-fetch-api'
import { loadFilePond } from '../models/filepond_loader'
import { throttle, debounce } from '../helpers/timing_helpers'
const gif = new GiphyFetch('LWEdndeRhD8jeht11s9pvYl9SYnLqQmv')
let controller = null

export default class GifpickerController extends Controller {
  static targets = ['modal', 'search', 'results', 'gifUrl']

  connect() {
    controller = this
    this.selectedGifs = []
    this.debounceTimer = null
    this.grid = null
    this.index = null
    this.renderGrid = throttle(() => {
      if (this.currentContainer) {
        this.buildGrid()
      }
    }, 300)

    this.debouncedSearch = debounce((query, index) => {
      this.currentContainer = document.getElementById(`results_${index}`)

      if (!this.currentContainer) return

      query = query.trim()

      if (query.length > 0 && query.length < 2) return

      query = query || 'trending'

      if (query === this.currentQuery) return
      if (controller.grid) {
        controller.grid()
      }

      this.currentQuery = query
      this.buildGrid()
    }, 1000)

    window.addEventListener('resize', this.renderGrid)

    if (globalThis.location.pathname.includes('messages')) {
      // controller.fetchGifs('trending', this.element.dataset.index)
      controller.currentContainer = document.getElementById(
        `results_${this.element.dataset.index}`
      )
      controller.currentQuery = 'trending'
      setTimeout(() => {
        controller.buildGrid()
      }, 100)
    }
  }

  openModal(event) {
    event.preventDefault()
    this.resetSelection()

    const index = event.currentTarget.dataset?.index
    this.element.dataset.index = index
    this.index = index

    if (event.target.dataset?.edit === 'true') {
      const oldModalElement = document.getElementById('shareRecipeModal')
      const oldModal = new bootstrap.Modal(oldModalElement)
      oldModal.hide()
    }

    const modalElement = document.getElementById('gifPickerModal' + index)
    const modal = new bootstrap.Modal(modalElement)
    this.el = document.getElementById(`results_${index}`)
    modalElement.addEventListener(
      'shown.bs.modal',
      () => {
        controller.currentContainer = document.getElementById(
          `results_${index}`
        )
        controller.currentQuery = 'trending'

        controller.buildGrid()
      },
      { once: true }
    )

    modal.show()
  }

  async buildGrid() {
    if (!this.currentContainer) return

    const width = this.currentContainer.clientWidth
    // this.currentContainer.innerHTML = ''
    const currentQuery = this?.currentQuery || 'trending'
    setTimeout(() => {
      try {
        controller.grid = renderGrid(
          {
            width,
            fetchGifs: (offset) =>
              gif.search(currentQuery, { offset, limit: 25 }),
            columns: width < 576 ? 2 : width < 768 ? 3 : 4,
            gutter: 8,
            onGifClick: (gif, event) => {
              event.preventDefault()
              controller.toggleGifSelection(gif, event)
            }
          },
          this.currentContainer
        )
      } catch (err) {
        console.error('renderGrid failed:', err)
      }
    }, 200)
  }

  closeModal(index) {
    const modalElement =
      document.getElementById('gifPickerModal' + index) ||
      this.element.closest('.modal')
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement)
      if (modal) {
        modal.hide()
      } else {
        console.error('Bootstrap modal instance not found!')
      }
    } else {
      console.error('Modal target not found!')
    }

    this.resultsTarget.innerHTML = ''
    this.resetSelection()
  }

  searchGifs(event) {
    const index = event.target.dataset.index || this.element.dataset.index
    const value = event.target.value.trim()
    this.debouncedSearch(value, index)
  }

  async uploadGif(gif) {
    const messageGif = globalThis.location.pathname.includes('messages')
    // event.currentTarget.classList.add('disabled')
    const url = gif.images.original.url
    const index = this.index || this.gifUrlTarget.dataset.index

    const target =
      document.getElementById(`post_medias_${index}`) ||
      document.getElementById('new_message')

    if (target) {
      let filePond
      const FilePond = await loadFilePond()
      if (!messageGif) {
        $(target).removeClass('d-none')
        filePond = FilePond.find(target)

        if (!filePond) {
          filePond = FilePond.create(target, {
            beforeRemoveFile: (item) => {
              return new Promise((resolve, reject) => {
                this.showAlert(
                  'Confirmation',
                  'Are you sure? you want to remove this file?',
                  'warning'
                ).then((result) => {
                  if (result.isConfirmed) {
                    this.isValid()
                    resolve()
                  } else {
                    reject()
                  }
                })
              })
            }
          })
        }
      }

      const response = await fetch(url)
      if (!response.ok) {
        this.showAlert('Error', 'Failed to load GIF.', 'error')
        return
      }
      const blob = await response.blob()
      const file = new File([blob], `gif_${Date.now()}.gif`, {
        type: 'image/gif'
      })

      if (messageGif) {
        const messagePreviewController =
          this.application.getControllerForElementAndIdentifier(
            document.getElementById('new_message'),
            'message-preview'
          )
        if (messagePreviewController) {
          const attachement = document.getElementById('message_attachments')
          const currentFiles = Array.from(attachement.files)
          if (currentFiles.length >= 5) {
            const modal = bootstrap.Modal.getInstance($('#shareRecipeModal'))
            if (modal) modal.hide()
            $('.show_error')
              .html('You can upload max 5 attachments')
              .addClass('text-danger')
            return
          }
          const dt = new DataTransfer()

          for (let f of attachement.files) {
            dt.items.add(f)
          }
          dt.items.add(file)

          attachement.files = dt.files
          messagePreviewController.selectFile({}, file)
          const modal = bootstrap.Modal.getInstance($('#shareRecipeModal'))
          if (modal) modal.hide()
        }
      } else {
        filePond
          .addFile(file)
          .then(() => {
            if (
              $('.edit-post-details[data-index="' + index + '"]').length === 0
            ) {
              this.closeModal(index) // close gif modal after adding the gif for comment
            }
          })
          .catch((err) => {
            console.error('Error adding file to FilePond:', err)
            this.showAlert('Error', 'Failed to add GIF to post.', 'error')
          })
      }
    } else {
      console.error(`Target element post_medias_${index} not found`)
      this.showAlert('Error', 'Could not find media upload area.', 'error')
    }
  }

  showAlert(title, message, icon) {
    Swal.fire({
      customClass: {
        popup:
          'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
        htmlContainer: 'text-black-paint text-white'
      },
      animation: false,
      title: title,
      text: message,
      icon: icon,
      confirmButtonText: 'OK'
    })
  }

  toggleGifSelection(gif, event) {
    const card = event.target.closest('a')

    if (!card) return

    const index = controller.selectedGifs.findIndex((g) => g.id === gif.id)

    // Deselect
    if (index !== -1) {
      controller.selectedGifs.splice(index, 1)
      card.classList.remove('gif-selected')
      return
    }

    // Select
    controller.selectedGifs.push(gif)
    card.classList.add('gif-selected')
  }

  resetSelection() {
    this.currentContainer
      ?.querySelectorAll('.gif-selected')
      .forEach((el) => el.classList.remove('gif-selected'))

    this.currentQuery = 'trending'
    controller.selectedGifs = []
  }

  async done(event) {
    const button = event.currentTarget || event.target.parentElement

    if (controller.selectedGifs.length === 0) {
      this.showAlert('Select GIF', 'Please select at least one GIF.', 'warning')
      return
    }

    button.classList.add('gif-loading')
    button.querySelector('span').textContent = 'Uploading'

    for (const gif of controller.selectedGifs) {
      await this.uploadGif(gif)
    }

    this.closeModal(this.index)
    button.classList.remove('gif-loading')
    button.querySelector('span').textContent = 'Done'
  }

  disconnect() {
    window.removeEventListener('resize', this.renderGrid)

    if (this.grid?.remove) {
      this.grid.remove()
    }
  }

  hideAllTooltip() {
    setTimeout(() => {
      for (const tooltip of document.querySelectorAll('.tooltip')) {
        tooltip.remove()
      }
    }, 50)
  }
}
